<template>
  <p class="ds-text-2xs md:ds-text-xs text-white min-w-28">
    {{ creatorDescription }} favorited this athlete {{ createdDate }}
  </p>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('userData', ['userId']),
    ...mapGetters('athleteProfile', ['favoritesReceived']),

    favorite() {
      return this.favoritesReceived[0]
    },

    creator() {
      return this.favorite.creator
    },

    creatorDescription() {
      return this.creator.id == this.userId
        ? 'You'
        : `${this.creator.firstName} ${this.creator.lastName}`
    },

    createdDate() {
      const today = new Date().toLocaleDateString("en-US");
      const favoriteDate = new Date(this.favorite.createdDate).toLocaleDateString("en-US");
      return favoriteDate === today ? 'today' : `on ${favoriteDate}`;
    },
  },
}
</script>
<style scoped>
.min-w-28 {
  min-width: 7rem;
}
</style>
